import { render } from "./TeamsTable.vue?vue&type=template&id=564bdf08&scoped=true"
import script from "./TeamsTable.vue?vue&type=script&lang=js"
export * from "./TeamsTable.vue?vue&type=script&lang=js"

import "./TeamsTable.vue?vue&type=style&index=0&id=564bdf08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564bdf08"]])

export default __exports__